import type { ComponentType } from "react";
import type { BasicLeftPanelId } from "../../rails/railConfig";
import { AiMatchPanel } from "../AiMatchPanel";
import { CeramicsPanel, GemsPanel, MetalsPanel, OtherMaterialsPanel, PearlsPanel } from "./MaterialPanels";
import { GemHdrPanel, MetalHdrPanel } from "./LightPanels";
import { BackdropPanel, CameraPanel, ScenesPanel } from "./ScenePanels";
import { OutputPanel, SharePanel } from "./OutputPanels";

/** Basic mode's left panels, by rail id. */
export const BASIC_LEFT_PANELS: Record<BasicLeftPanelId, ComponentType> = {
  metals: MetalsPanel,
  gems: GemsPanel,
  ceramics: CeramicsPanel,
  pearls: PearlsPanel,
  otherMaterials: OtherMaterialsPanel,
  scenes: ScenesPanel,
  metalHdr: MetalHdrPanel,
  gemHdr: GemHdrPanel,
  backdrop: BackdropPanel,
  aiMatch: () => <AiMatchPanel embedded />,
  camera: CameraPanel,
  output: OutputPanel,
  share: SharePanel,
};
